type EventDetails = Record<string, unknown> | null | undefined;

const SHOT_EVENT_TYPE = "shot";
const GOAL_EVENT_TYPE = "goal";

export const EXPECTED_GOALS_POINT_DIAMETERS = [15, 20, 25, 30] as const;
export const DEFAULT_POINT_DIAMETER = EXPECTED_GOALS_POINT_DIAMETERS[0];
export const MISSING_EXPECTED_GOALS_SORT_VALUE = Number.NEGATIVE_INFINITY;

export function getFiniteNumericDetail(details: unknown, key: string): number | null {
	if (details === null || typeof details !== "object") {
		return null;
	}

	const detailValue = (details as Record<string, unknown>)[key];
	if (typeof detailValue === "number" && Number.isFinite(detailValue)) {
		return detailValue;
	}

	if (typeof detailValue !== "string" || detailValue.trim() === "" || Number.isFinite(Number(detailValue)) === false) {
		return null;
	}

	return Number(detailValue);
}

export function getExpectedGoals(details: EventDetails): number | null {
	return getFiniteNumericDetail(details, "xg");
}

export function getExpectedAssists(details: EventDetails): number | null {
	return getFiniteNumericDetail(details, "xa");
}

export function shouldDisplayExpectedGoalsColumn(eventType: string): boolean {
	return eventType === SHOT_EVENT_TYPE || eventType === GOAL_EVENT_TYPE;
}

export function getExpectedGoalsSortValue(details: EventDetails): number {
	const expectedGoals = getExpectedGoals(details);
	if (expectedGoals === null) {
		return MISSING_EXPECTED_GOALS_SORT_VALUE;
	}

	return expectedGoals;
}

export function getPointDiameterForExpectedGoals(expectedGoals: number | null): number {
	if (expectedGoals === null || expectedGoals < 0.01 || expectedGoals > 1) {
		return DEFAULT_POINT_DIAMETER;
	}

	if (expectedGoals <= 0.15) {
		return EXPECTED_GOALS_POINT_DIAMETERS[0];
	}
	if (expectedGoals <= 0.3) {
		return EXPECTED_GOALS_POINT_DIAMETERS[1];
	}
	if (expectedGoals <= 0.6) {
		return EXPECTED_GOALS_POINT_DIAMETERS[2];
	}

	return EXPECTED_GOALS_POINT_DIAMETERS[3];
}

export function formatExpectedMetric(metric: number): string {
	return metric.toFixed(2);
}
